import {htmlToText as editorHtmlToText} from '@frontapp/editor-html';

import {sanitizeHtml} from '../../../src/services/sanitization/domPurify';
import {shortcodeToUnified} from '../../helpers/emoji/emojiTextHelpers';

/*
 * API.
 */

export function htmlToText(html: string) {
  // Clean the HTML and replace emoji images.
  const cleanHtml = sanitizeHtml(html, {
    hooks: {uponSanitizeElement},
  });

  // Convert it to text.
  return editorHtmlToText(cleanHtml);
}

/*
 * Sanitization hooks.
 */

/** Custom logic to help converting HTML to Text. */
function uponSanitizeElement(currentNode: Element) {
  emojiImageToUnified(currentNode);
}

/** Replace emoji images with their unicode text representation. */
function emojiImageToUnified(currentNode: Element) {
  const document = currentNode.ownerDocument;

  // Only applies to images with parent nodes (the parent node is necessary to `replaceChild`).
  if (!document || currentNode.tagName !== 'IMG' || !currentNode.parentNode) {
    return;
  }

  // Extract the colons representation.
  const emojiColons =
    currentNode.getAttribute('data-front-emoji-shortcode') ??
    currentNode.getAttribute('front-emoji-shortcode');
  if (!emojiColons) {
    return;
  }

  // Replace this node by the colons representation.
  const emojiUnified = shortcodeToUnified(emojiColons);
  const emojiContainer = document.createElement('span');
  emojiContainer.textContent = emojiUnified;
  currentNode.parentNode.replaceChild(emojiContainer, currentNode);
}
